(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(scope) {
    (scope || document).querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  var observer = null;
  if (!reduce && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
  }

  function observe(scope) {
    if (!observer) return showAll(scope);
    (scope || document).querySelectorAll('.reveal:not(.is-in)').forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    observe(document);

    /* Sticky header state */
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 12);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: sections re-render without a page load */
  document.addEventListener('shopify:section:load', function (event) {
    showAll(event.target);
    var header = event.target.querySelector('[data-header]');
    if (header && window.scrollY > 12) header.classList.add('is-scrolled');
  });
  document.addEventListener('shopify:section:select', function (event) {
    showAll(event.target);
  });

  window.FoliantReveal = { observe: observe, showAll: showAll };
})();
